<template>
  <div class="namepage">
    <div class="nametitle">
      <span>{{deptInfo.Name}}</span>
    </div>
    <div v-html="deptInfo.Synopsis">{{deptInfo.WXSynopsis}}</div>
  </div>
</template>
<script>
import { GetDptSynopsis } from "@/services/getData.js";
import weui from "weui.js";
export default {
  name: "office-name",
  data() {
    return {
      deptInfo: {},
      guid: this.$route.query.guid
    };
  },
  created: function() {
    var loading = weui.loading("loading", {
      className: "custom-classname",
      content: "加载中"
    });
    GetDptSynopsis(this.guid).then(response => {
      loading.hide();
      this.deptInfo = response.data;
    });
  }
};
</script>
<style>
.namepage {
  height: 100%;
  width: 100%;
  background: white;
  padding: 0 0.12rem;
  box-sizing: border-box;
}
.nametitle {
  height: 0.8rem;
  line-height: 0.8rem;
  text-align: center;
  font-size: 0.3rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  border-bottom: 0.01rem solid rgba(221, 221, 221, 1);
}
</style>



// WEBPACK FOOTER //
// src/components/section-office/office-name.vue